import { render, staticRenderFns } from "./record-kpi-table.vue?vue&type=template&id=a35edba0"
import script from "./record-kpi-table.vue?vue&type=script&lang=js"
export * from "./record-kpi-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports